<template>
  <div class="padding">
    <div class="row">
      <div class="col-sm-12">
        <div class="m-b-sm">
          <h5 class="m-b-md _300">Outlets</h5>
        </div>
      </div>
    </div>

    <div class="clearfix"/>

    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <v-server-table 
            ref="datatable" 
            :url="api" 
            :name="tableName" 
            :columns="columns" 
            :options="options"/>
        </div>
      </div>
    </div>

    <outlet-form :outlet="outlet"/>
  </div>
</template>

<script>
import { Event } from '../../event-bus';
import outletForm from './outlet-form.vue';
import permission from '../../libs/permissions';

const TableName = 'VUETABLE_OUTLET';

export default {
    components: {
        outletForm,
    },

    data() {
        var that = this;

        return {
            outlet: {},
            tableName: TableName,
            columns: ['name', 'address', 'latitude', 'longitude'],
            options: {
                permission: {
                    create: permission.SAVE_OUTLET,
                    delete: permission.DELETE_OUTLET,
                },
                checkbox: {
                    api_delete: Laroute.route('outlets.delete'),
                    delete_title: 'Delete Outlet',
                },
                create_btn: {
                    title: 'Create Outlet',
                    action: () => {
                        that.showForm(null);
                    },
                },
                rowClassCallback: that.getRowClass,
                rowClickCallback: that.showForm,
                csv_url: Laroute.route('outlets.export', { type: 'csv' }),
                pdf_url: Laroute.route('outlets.export', { type: 'pdf' }),
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('outlets.index');
        },
        searchQuery() {
            return this.$refs.datatable.query;
        },
        canUpdate() {
            return this.can(this.permission.SAVE_OUTLET);
        },
    },

    created() {
        this.initOutlet();

        Event.$on('outletChanged', () => {
            this.refreshTable();
            this.initOutlet();
        });
    },

    methods: {
        initOutlet() {
            this.outlet = {
                id: null,
                name: null,
                address: null,
                latitude: null,
                longitude: null,
            };
        },

        setOutlet(outlet) {
            this.outlet = outlet;
        },

        getRowClass() {
            if (this.canUpdate) {
                return 'pointer';
            }
        },

        getOutlet(id) {
            var that = this;
            let api = Laroute.route('outlets.show', { id: id });

            axios.get(api).then(function(res) {
                that.setOutlet(res.data);
                $('#outlet-form').modal('show');
            });
        },

        showForm(data) {
            if (data == null) {
                this.initOutlet();
                $('#outlet-form').modal('show');
            } else {
                if (!this.canUpdate) return;

                this.getOutlet(data.id);
            }
        },

        refreshTable() {
            this.$refs.datatable.getData();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/outlet/outlet-list.vue